import { useDimensions } from '@lumapps/responsive';

import { BLOCK_BREAKPOINT } from '../components/Block/constants';

/** Setup `useDimentions` with the `BLOCK_BREAKPOINT` */
export const useBlockBreakpoints = () => useDimensions({ breakpoints: BLOCK_BREAKPOINT });
